import * as Sentry from '@sentry/react';
import vars from '@/config/vars';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: vars.sentryDsn,
  });
}
